<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
            div.pull-right.m-t-sm
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    :disabled="onLoading('save-purchase-order')",
                    @click="cancel",
                ) Cancel

                button.md-btn.md-raised.m-b-sm.w-xs.green(
                    :disabled="onLoading('save-purchase-order')",
                    @click="submit",
                )
                    v-loading(loader="save-purchase-order") Create

            nav(aria-label="breadcrumb")
                ol.breadcrumb.white.m-b-0.p-b-0
                    li.breadcrumb-item
                        router-link(to="/") Purchase Order
                    li.breadcrumb-item.active Create
    .padding
        .box
            .box-header.dker
                h3 New Purchase Order
            .box-divider.m-a-0
            .box-body
                .p-a
                    step-wizard

                form
                    fieldset(:disabled="onLoading('save-purchase-order')")
                        .row
                            .col-md-5
                                .form-group
                                    label Deliver to
                                    outlet-selector(
                                        :class="{'has-error': errors.has('outlet') }"
                                        v-model="purchaseOrder.outlet_id",
                                        :use-vuex="false"
                                    )
                                    span.text-danger(v-if="errors.has('outlet')")
                                        | {{ errors.first('outlet') }}

                                .form-group
                                    label Supplier
                                    supplier-selector(
                                        :class="{'has-error': errors.has('supplier') }"
                                        v-model="purchaseOrder.supplier_id"
                                    )
                                    span.text-danger(v-if="errors.has('supplier')")
                                        | {{ errors.first('supplier') }}

                                .form-group
                                    label Expected Delivery Date
                                    .row
                                        .col-xs-12
                                            vue-datepicker(
                                                type="date",
                                                width="100%",
                                                v-model="deliveryDate",
                                                :disabled="onLoading('save-purchase-order')",
                                                lang="en",
                                                :editable="false",
                                                :clearable="false",
                                                :shortcuts="false",
                                                format="DD/MM/YYYY"
                                            )
</template>

<script>
import purchaseMixin from './purchase-order-mixin';
import stepWizard from './purchase-order-step.vue';
import { mapActions } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: { stepWizard },

    mixins: [purchaseMixin],

    data() {
        return {
            purchaseOrder: {
                outlet_id: null,
                supplier_id: null,
                delivery_date: moment().format('YYYY-MM-DD'),
            },
            hasValidationError: false,
        };
    },

    computed: {
        deliveryDate: {
            get() {
                return this.purchaseOrder.delivery_date;
            },
            set(date) {
                this.purchaseOrder.delivery_date = moment(date).format(
                    'YYYY-MM-DD',
                );
            },
        },
    },

    methods: {
        ...mapActions('purchaseOrder', ['createPurchaseOrder']),

        cancel() {
            this.$router.push('/');
        },

        async submit() {
            this.errors.clear();
            this.hasValidationError = false;

            this.validateField(this.purchaseOrder.outlet_id, 'outlet');
            this.validateField(this.purchaseOrder.supplier_id, 'supplier');

            if (this.hasValidationError) return;

            try {
                const po = await this.createPurchaseOrder(this.purchaseOrder);
                this.$router.push(`/${po.id}`);
            } catch (e) {
                if (e.response.status === 409) {
                    this.swalWarning({
                        text: 'Outlet delivery address is not set',
                    });
                } else {
                    this.swalError({ text: e });
                }
            }
        },

        validateField(value, field) {
            if (_.isNull(value) || value == 0 || String(value).trim() == '') {
                this.errors.add({
                    field: field,
                    msg: `The ${field} field is required`,
                });

                this.hasValidationError = true;

                return false;
            }

            return true;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/purchase-order/purchase-order-create.vue